export const UNINSURED_OPTION = "No insurance";
export const OUT_OF_NETWORK_INSURANCE_OPTION = "Insurance isn’t on the list";
export const CATCH_ALL_INSURANCE_OPTIONS = [UNINSURED_OPTION, OUT_OF_NETWORK_INSURANCE_OPTION];

export const InsuranceCarrierEnum = {
  CDPHP_MEDICAID: "CDPHP Medicaid",
  CDPHP: "CDPHP",
  MVP_HEALTHCARE: "MVP Healthcare",
  MVP_MEDICAID: "MVP Medicaid",
  MVP: "MVP",
  OTHER: "Other",
} as const;
